import { Tag, Tooltip } from "antd";
import dayjs from "dayjs";
import "dayjs/locale/tr";
import { CopyElement } from "@UI";

dayjs.locale("tr");
const useLogics = () => {
  const columns = [
    {
      title: "Belge Numarası",
      key: "invoice_number",
      dataIndex: "invoice_number",
      width: 150,
      fixed: true,
      render: (_, record) => {
        return (
          <div className="big-text-container">
            <div className="big-text">
              <Tooltip title="Fatura Detayı" placement="top">
                {record?.invoice_number || "-"}
              </Tooltip>
              <CopyElement text={record?.invoice_number || "-"} />
            </div>
          </div>
        );
      },
    },
    {
      title: "İşlem Tarihi",
      key: "payment_date",
      dataIndex: "payment_date",
      width: 100,
      render: (date) =>
        dayjs(date).isValid() ? dayjs(date).format("DD MMMM YYYY") : "-",
    },
    {
      title: "Vade Tarihi",
      key: "net_due_date",
      dataIndex: "net_due_date",
      width: 100,
      render: (date) =>
        dayjs(date).isValid() ? dayjs(date).format("DD MMMM YYYY") : "-",
    },
    {
      title: "Tutar",
      key: "amount",
      dataIndex: "amount",
      width: 100,
      align: "right",
      render: (amount) => {
        const formatted = new Intl.NumberFormat("tr-TR", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(Number(amount));

        return `${formatted} ₺`;
      },
    },
    {
      title: "Durum",
      key: "payment_status",
      dataIndex: "payment_status",
      width: 100,
      render: (status) => {
        let color = "default";

        switch (status) {
          case "Ödendi":
            color = "green";
            break;
          case "Ödenmedi":
            color = "red";
            break;
          case "Kısmi Ödendi":
            color = "orange";
            break;
          default:
            color = "default";
        }

        return (
          <Tag
            color={color}
            style={{ borderRadius: 8, width: "100%", textAlign: "center" }}
          >
            ● {status}
          </Tag>
        );
      },
    },
  ].filter(Boolean);

  const excelColumns = [];
  const searchKeys = [];
  return { columns, excelColumns, searchKeys };
};

export default useLogics;
